<template>
  <div v-show="isActive">
    <slot />
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  value: {
    type: String,
    required: true,
  },
  activeTab: {
    type: String,
    required: true,
  },
});

const isActive = computed(() => props.value === props.activeTab);
</script>
